import normalizeDateToStr from '../../utils/dateHelpers'
export default function useCancelButtonState({
  selectedDates,
  userReservations
}) {
  const todayStr = new Date().toISOString().split("T")[0];

  const hasReservationOnSelectedDates = userReservations.some(r =>
    selectedDates.some(d => {
      const dateStr = new Date(d).toISOString().split("T")[0];
      return r.date === dateStr;
    })
  );
  
  const hasPastDatesSelected = selectedDates.some(d => {
    const dateStr = new Date(d).toISOString().split("T")[0];
    return dateStr < todayStr;
  });

  const shouldDisableCancelButton =
    selectedDates.length === 0 ||
    !hasReservationOnSelectedDates ||
    hasPastDatesSelected;

  return { shouldDisableCancelButton };
}
